import React, { ReactElement } from 'react';
import icon from 'assets/images/feedback.svg';
import logoDIS from 'assets/images/Logo_Notify360.svg';
import { useAppSelector } from 'app';

export function Logo(): ReactElement {
  const dmsTypeId = useAppSelector((state) => state.user.dmsTypeId);
  const showLogoDIS = location.pathname === '/dislogin' || dmsTypeId === 12;
  if(showLogoDIS) {
      return <img src={`${logoDIS}`} alt="Notify" title="Notify" height="30px" style={{ paddingLeft: "15px" }} />;
  }
  else{
      return <img src="/logo.png" alt="TargetCRM" title="TargetCRM" height="40px" style={{ paddingLeft: "15px" }} />;    
  }       
}

export function feedbackIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={`icon icon-${props.name}`}>
      <use xlinkHref={`${icon}#icon-${props.name}`} />
    </svg>
  );
}


export default Logo;
